/// <reference types="vite-plugin-svgr/client" />
import { useEffect, useMemo } from 'react'
import { Flex } from '@mantine/core'

import { ShadowBox } from '@/components/@Shared/ShadowBox/ShadowBox'
import type { UsersSummaryProps } from '@/components/@Shared/UserManagmentCharts/UserSummary/UsersSummary.types'
import { Loader } from '@/components/Loader/Loader'
import { MonthPicker } from '@/components/MonthPicker/MonthPicker'
import { Title } from '@/components/Title/Title'

import UsersIcon from '@/assets/icons/users.svg?react'

import classes from './UsersSummary.module.css'

export function UsersSummary({
  data,
  endDate,
  isLoading,
  onMonthChange,
  onUpdateChartsData,
  startDate,
}: UsersSummaryProps) {
  const count = useMemo<number>(() => data?.count ?? 0, [data])

  useEffect(() => {
    if (!onUpdateChartsData) return

    const users = {
      endDate: endDate.toISOString(),
      startDate: startDate.toISOString(),
      value: count,
    }

    onUpdateChartsData(users, 'users')
  }, [count, startDate, endDate, onUpdateChartsData])

  return (
    <ShadowBox
      w={{
        base: '100%',
        lg: '30%',
      }}
    >
      <Flex direction="column" h={120} justify="start">
        <Flex align="center" justify="space-between">
          <Flex align="center" gap={10}>
            <UsersIcon className={classes.icon} />

            <Title mb={0} variant="h2">
              Users
            </Title>
          </Flex>

          <MonthPicker month={endDate} onChange={onMonthChange} />
        </Flex>

        <Flex align="center" h="100%" justify="center">
          {isLoading ? (
            <Loader isMinimized />
          ) : (
            <Title variant="h1_extra_big">{count}</Title>
          )}
        </Flex>
      </Flex>
    </ShadowBox>
  )
}
